import { createFileRoute, notFound } from '@tanstack/react-router';
import {
  type ViewParam,
  isValidView,
  type SubnavParam,
  type TypeParam,
  isValidSubNav,
  isValidType,
  fromSearchParam,
  fromSearchFlag,
} from './-utils';

type SearchParams = {
  copyAudience?: boolean;
  isEdit?: boolean;
  isSystemTemplate?: boolean;
  seedId?: string;
  startFresh?: boolean;
  templateId?: string;
  usePassedRecipients?: boolean;
};

type Params = {
  id: string;
  subNav: SubnavParam;
  type: TypeParam;
  view: ViewParam;
};

export const Route = createFileRoute('/bulk_/$subNav_/$type_/$id_/$view')({
  staticData: { team: 'fe-messaging' },
  params: {
    parse: (params): Params => {
      if (!isValidType(params.type)) {
        throw notFound();
      }
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      if (!params.id) {
        throw notFound();
      }
      if (!isValidView(params.view)) {
        throw notFound();
      }
      return params as Params;
    },
  },
  validateSearch: ({
    copyAudience,
    isEdit,
    seedId,
    startFresh,
    templateId,
    isSystemTemplate,
    usePassedRecipients,
  }: Record<string, unknown>): SearchParams => ({
    copyAudience: fromSearchFlag(copyAudience),
    isEdit: fromSearchFlag(isEdit),
    isSystemTemplate: fromSearchFlag(isSystemTemplate),
    seedId: fromSearchParam(seedId),
    startFresh: fromSearchFlag(startFresh),
    templateId: fromSearchParam(templateId),
    usePassedRecipients: fromSearchFlag(usePassedRecipients),
  }),
});
